import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styled';
import LoginContent from './LoginContent';
import MainContent from './MainContent';

const Sidebar = ({ onClose, open }) => {
  const [isShowingLoginContent, showLoginContent] = useState(false);
  const toggleContent = () => showLoginContent(prevState => !prevState);

  return (
    <Styled.Wrapper open={open} onClose={onClose}>
      {isShowingLoginContent
        ? <LoginContent handleClick={toggleContent} />
        : <MainContent handleClick={toggleContent} handleCloseSidebar={onClose} />
      }
    </Styled.Wrapper>
  )
};

Sidebar.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

Sidebar.defaultProps = {
  open: 'false',
};

export default memo(Sidebar);